module.exports = __webpack_public_path__ + "media/assets/images/flags/yt-05705007749ce5246f8fd8b3807ad9b1.svg";